























































import Vue from 'vue';

import { Usuario } from '../../../../back/src/entity/Usuario';

export default Vue.extend({
  name: 'TheUsuariosDetalhes',
  props: {
    usuario: {
      type: Object as () => Usuario,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column mt-4';
      }
      return '';
    },
    vColClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'py-1';
      }
      return '';
    },
  },
});
